module.exports = __webpack_public_path__ + "static/media/SantaMisa08Sep2021Obispo.30476327.jpg";